<script setup>
import IconSentimentSad from "@/assets/icons/IconSentimentSad.vue";
import IconSentimentGood from "@/assets/icons/IconSentimentGood.vue";
import IconSentimentNeutral from "@/assets/icons/IconSentimentNeutral.vue";

const props = defineProps({
  type: {
    type: String,
    required: true,
    default: () => "neutral"
  },
  modelValue: {
    type: Boolean,
    required: true
  }
});

const emit = defineEmits(["update:modelValue"]);

const handleSentimentClick = () => {
  emit("update:modelValue", !props.modelValue);
};
</script>

<template>
  <div
    class="sentiment"
    :class="[`sentiment--${type}`, { 'sentiment--active': modelValue }]"
    @click="handleSentimentClick"
  >
    <IconSentimentSad v-if="type === 'sad'" />
    <IconSentimentGood v-else-if="type === 'good'" />
    <IconSentimentNeutral v-else />
  </div>
</template>

<style scoped lang="scss">
.sentiment {
  display: inline-flex;
  align-items: center;
  border-radius: 8px;
  padding: 4px;
  cursor: pointer;
  user-select: none;

  background: var(--background-01);

  // Базовые стили для неактивного состояния
  &--neutral:not(.sentiment--active) {
    background: var(--background-01);
    color: var(--point-emoji-meh);

    &:hover {
      background: var(--background-bg-hover);
    }
  }

  &--sad:not(.sentiment--active) {
    background: var(--background-01);
    color: var(--point-emoji-frown);

    &:hover {
      background: var(--background-bg-hover);
    }
  }

  &--good:not(.sentiment--active) {
    background: var(--background-01);
    color: var(--point-emoji-smile);

    &:hover {
      background: var(--background-bg-hover);
    }
  }

  // Активные стили
  &--neutral.sentiment--active {
    background: var(--point-emoji-meh);
    color: var(--text-text-on-inverse);
  }

  &--sad.sentiment--active {
    background: var(--point-emoji-frown);
    color: var(--text-text-on-inverse)
  }

  &--good.sentiment--active {
    background: var(--point-emoji-smile);
    color: var(--icon-icon-on-inverse)
  }
}
</style>